// PostCard.js
'use strict';
import { connect } from 'react-redux';

import PostCard from '../component/PostCard.jsx';

import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import { PREVIEW_PRESET } from '../RemoteConfigKeys.js';

const size1x = '512x512'; // TODO: remote config
const size2x = '512x512'; // TODO: remote config

const mapStateToProps = (state, { postId }) => {
  const canViewMedia = getMessageData(state, postId, 'canViewMedia');
  const assetIds = getMessageData(state, postId, 'assetIds');
  const firstAssetContentType = getAssetData(
    state,
    [assetIds?.[0]],
    'contentType'
  );
  const hasVerified = getRemoteConfigData(state, PREVIEW_PRESET) === 'clear';
  const preset = hasVerified ? 'clear' : 'blurred';
  const jpg1x = getMessageThumbnail(state, postId, '', size1x, 'jpg', preset);
  const jpg2x = getMessageThumbnail(state, postId, '', size2x, 'jpg', preset);
  const webp1x = getMessageThumbnail(state, postId, '', size1x, 'webp', preset);
  const webp2x = getMessageThumbnail(state, postId, '', size2x, 'webp', preset);
  return {
    firstAssetContentType,
    jpg1x,
    jpg2x,
    webp1x,
    webp2x,
    canViewMedia,
    assetIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetail: ({ postId }) =>
      dispatch(fetchMessageDetail({ id: postId })),
    fetchDrmLicenseAvailability: ({ messageId, keySystem }) =>
      dispatch(fetchDrmLicenseAvailability({ messageId, keySystem })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCard);
